
import Vue from "vue";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";

export default Vue.extend({
  name: "tran-progam-low-income-content",
  mixins: [UIFeatureMixin],
});
